export default __webpack_public_path__ + "d03ce55.png";